import React, { useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { Button, Labeled, TextField } from "react-admin";
import { settings } from "app";
import RoomField from "server/components/Fields/RoomField";
import EditIcon from "@mui/icons-material/Edit";
import SessionExamSlotEditForm from "./SessionExamSlotEditForm";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import GoogleRoomField from "server/components/Fields/GoogleRoomField";
import { RoomSource } from "utils/constants";

const SessionExamSlotDate = ({ slot, academicSessionId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const [isSlotInfoEditing, setIsSlotInfoEditing] = useState(false);

  // An exam is held either in a physical room or in a Google classroom
  const isOnline = slot?.roomSource === RoomSource.GoogleCourse;

  const handleSlotInfoEditClick = () => {
    setIsSlotInfoEditing(true);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox) }}
    >
      {isSlotInfoEditing ? (
        <SessionExamSlotEditForm
          setIsSlotInfoEditing={setIsSlotInfoEditing}
          slot={slot}
          academicSessionId={academicSessionId}
        />
      ) : (
        <>
          <Grid
            item
            xs={12}
            md={3}
          >
            {isOnline ? (
              <Labeled label="Google зала">
                <GoogleRoomField source="slot.googleCourseRefId" />
              </Labeled>
            ) : (
              <Labeled label="Зала">
                <RoomField source="slot.roomId" />
              </Labeled>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Дата">
              <TextField source="slot.dateFormatted" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Начало">
              <TextField source="slot.startTimeFormatted" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Край">
              <TextField source="slot.endTimeFormatted" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
          >
            <SecuredComponent permission={permissions.canUpdateSessionExamSlots}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<EditIcon />}
                label="Редактирай"
                onClick={handleSlotInfoEditClick}
              />
            </SecuredComponent>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SessionExamSlotDate;
